export default __webpack_public_path__ + "22782067cc38a275b8f34fa6b92435e1.png";